import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'xos-download-app',
  templateUrl: './download-app.component.html',
  styleUrls: ['./download-app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DownloadAppComponent {}
